interface Props {
  className?: string;
}

export const UpIcon = ({ className }: Props) => (
  <div className={className}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8653 3.23136L12.2113 1.88533L10.8653 0.539307L9.51928 1.88533L10.8653 3.23136ZM26.0961 35.5969C26.6011 35.5969 27.0853 35.3963 27.4424 35.0393C27.7994 34.6822 28 34.198 28 33.693C28 33.1881 27.7994 32.7039 27.4424 32.3468C27.0853 31.9898 26.6011 31.7892 26.0961 31.7892V35.5969ZM21.7306 11.4046L12.2113 1.88533L9.51928 4.57738L19.0386 14.0967L21.7306 11.4046ZM9.51928 1.88533L0 11.4046L2.69205 14.0967L12.2113 4.57738L9.51928 1.88533ZM8.96145 3.23136V22.2699H12.7692V3.23136H8.96145ZM22.2884 35.5969H26.0961V31.7892H22.2884V35.5969ZM8.96145 22.2699C8.96145 25.8044 10.3655 29.1942 12.8648 31.6935C15.3641 34.1928 18.7539 35.5969 22.2884 35.5969V31.7892C19.7638 31.7892 17.3425 30.7863 15.5573 29.0011C13.7721 27.2158 12.7692 24.7946 12.7692 22.2699H8.96145Z"
        fill="currentColor"
      />
    </svg>
  </div>
);
